import { emptyFusionHubApi } from "src/common/service/fusionHub/emptyFusionHubApi";

export type FortnoxIntegrationConfig = {
	id: number;
	integrationId: number;
	type: "STANDARD" | "LEGACY";
	additionalScopes: string[];
	expiresAt?: string;
};

export const fortnoxApi = emptyFusionHubApi.injectEndpoints({
	endpoints: (builder) => ({
		getFortnoxAuthorizationUrl: builder.query<
			{ authorizationUrl: string },
			{
				companyDomainId: string;
				successRedirectUrl: string;
				errorRedirectUrl: string;
				additionalScopes?: string[];
			}
		>({
			query: ({
				companyDomainId,
				successRedirectUrl,
				errorRedirectUrl,
				additionalScopes,
			}) => {
				const params = new URLSearchParams({
					successRedirectUrl,
					errorRedirectUrl,
					companyDomainId,
					accountType: "service",
				});

				if (additionalScopes) {
					for (const scope of additionalScopes) {
						params.append("additionalScopes", scope);
					}
				}

				return {
					url: `/integrations/fortnox/proxy-authorization-url?${params.toString()}`,
				};
			},
		}),
		getFortnoxReauthorizeUrl: builder.query<
			{ authorizationUrl: string },
			{
				integrationId: number;
				successRedirectUrl: string;
				errorRedirectUrl: string;
				additionalScopes?: string[];
			}
		>({
			query: ({
				integrationId,
				successRedirectUrl,
				errorRedirectUrl,
				additionalScopes,
			}) => {
				const params = new URLSearchParams({
					successRedirectUrl,
					errorRedirectUrl,
					accountType: "service",
				});

				if (additionalScopes) {
					for (const scope of additionalScopes) {
						params.append("additionalScopes", scope);
					}
				}

				return {
					url: `/integrations/${integrationId}/fortnox-raw/proxy-re-authorization-url?${params.toString()}`,
					method: "GET",
				};
			},
		}),

		getStatus: builder.query<{ refreshTokensPausedUntil: string | null }, void>(
			{
				query() {
					return "/integrations/fortnox/status";
				},
			},
		),
		getFortnoxIntegrationConfig: builder.query<
			FortnoxIntegrationConfig,
			{ integrationId: string }
		>({
			query: ({ integrationId }) => ({
				url: `/integrations/${integrationId}/fortnox-raw/config`,
				method: "GET",
			}),
			providesTags: ["Integrations"],
		}),
	}),
	overrideExisting: "throw",
});

export const {
	useLazyGetFortnoxAuthorizationUrlQuery,
	useLazyGetFortnoxReauthorizeUrlQuery,
	useGetStatusQuery,
	useGetFortnoxIntegrationConfigQuery,
} = fortnoxApi;
